import {
  parseMTDateString,
} from '@bingads-webui-campaign-react/asset-library-model';
import { parseSync } from '@bingads-webui/safe-json';

// perf related fields
const transformPerfMetricsResponse = (img, i18n) => {
  const res = {
    usedByCount: img.UsedByCount,
  };

  if (i18n.formatDecimal && i18n.formatDecimalToFixed && i18n.formatPercentToFixed) {
    // # performance rating
    const performanceRating = img.PerformanceRating || {};
    res.performanceLabel = '-';
    if (performanceRating.Rating === 'Best' || performanceRating.Rating === 'Good' || performanceRating.Rating === 'Low') {
      res.performanceLabel = performanceRating.Rating;
    }
    res.performanceLabelBestPercentage = i18n.formatPercentToFixed((performanceRating.PerformanceLabelBestPercentage || 0) / 100, { digits: 2 });
    res.performanceLabelGoodPercentage = i18n.formatPercentToFixed((performanceRating.PerformanceLabelGoodPercentage || 0) / 100, { digits: 2 });
    res.performanceLabelLowPercentage = i18n.formatPercentToFixed((performanceRating.PerformanceLabelLowPercentage || 0) / 100, { digits: 2 });
    res.performanceLabelLearningPercentage = i18n.formatPercentToFixed((performanceRating.PerformanceLabelLearningPercentage || 0) / 100, { digits: 2 });
    res.performanceLabelUnratedPercentage = i18n.formatPercentToFixed((performanceRating.PerformanceLabelUnratedPercentage || 0) / 100, { digits: 2 });

    // # performanceMetrics
    const performanceMetrics = img.PerformanceMetrics || {};
    res.impressions = i18n.formatDecimal(performanceMetrics.Impressions || 0);
    res.clicks = i18n.formatDecimal(performanceMetrics.Clicks || 0);
    res.CTR = i18n.formatPercentToFixed((performanceMetrics.CTR || 0) / 100, { digits: 2 });
    res.spend = i18n.formatDecimalToFixed(performanceMetrics.Spend || 0);

    // # periodPerformanceMetrics
    const periodPerformanceMetrics = img.PeriodPerformanceMetrics || {};
    res.periodImpressions = i18n.formatDecimal(periodPerformanceMetrics.Impressions || 0);
    res.periodClicks = i18n.formatDecimal(periodPerformanceMetrics.Clicks || 0);
    res.periodCTR = i18n.formatPercentToFixed((periodPerformanceMetrics.CTR || 0) / 100, { digits: 2 });
    res.periodSpend = i18n.formatDecimalToFixed(periodPerformanceMetrics.Spend || 0);

    // # performanceMetricsChange
    const performanceMetricsChange = img.PerformanceMetricsChange || {};
    res.impressionsChange = i18n.formatDecimal(performanceMetricsChange.Impressions || 0);
    res.clicksChange = i18n.formatDecimal(performanceMetricsChange.Clicks || 0);
    res.CTRChange = i18n.formatPercentToFixed((performanceMetricsChange.CTR || 0) / 100, { digits: 2 });
    res.spendChange = i18n.formatDecimalToFixed(performanceMetricsChange.Spend || 0);

    // # performanceMetricsChangePercentage
    const performanceMetricsChangePercentage = img.PerformanceMetricsChangePercentage || {};
    res.impressionsChangePercentage = i18n.formatPercentToFixed((performanceMetricsChangePercentage.Impressions || 0) / 100, { digits: 2 });
    res.clicksChangePercentage = i18n.formatPercentToFixed((performanceMetricsChangePercentage.Clicks || 0) / 100, { digits: 2 });
    res.CTRChangePercentage = i18n.formatPercentToFixed((performanceMetricsChangePercentage.CTR || 0) / 100, { digits: 2 });
    res.spendChangePercentage = i18n.formatPercentToFixed((performanceMetricsChangePercentage.Spend || 0) / 100, { digits: 2 });
  }

  return res;
};

export const transformImageResponse = (img, i18n) => {
  const asset = {
    folderAssetType: img.FolderAssetType,

    id: img.IdString,
    name: img.Text,
    url: img.Url,
    width: img.Width,
    height: img.Height,
    createdTime: parseMTDateString(i18n, img.UploadedTime),
    modifiedTime: parseMTDateString(i18n, img.ModifiedTime),
    originalHeight: img.OriginalHeight,
    originalWidth: img.OriginalWidth,
    originalUrl: img.OriginalUrl,

    cropSettings: img.CropSettings,
    cropSettingOnOriginal: img.CropSettingOnOriginal,
    placementSettings: img.PlacementSettings,

    type: img.Type,
    sourceType: img.SourceType,
    metadata: undefined,
  };

  if (img.Metadata && img.Metadata.replaceAll) {
    asset.metadata = parseSync(img.Metadata.replaceAll(encodeURIComponent(','), ','));
  }

  const metrics = transformPerfMetricsResponse(img, i18n);

  const isSceneKeyFrame = asset.metadata && asset.metadata.keyFrame;

  return { ...asset, ...metrics, isSceneKeyFrame };
};
